import React, { FC } from "react"

import { classNames } from "../../utils/Helpers"
import { InputProps } from "../../utils/Interfaces"

export const InputBasic: FC<InputProps> = ({
    name,
    value,
    error,
    label,
    posting,
    required,
    blurHandler,
    changeHandler,
    placeHolder,
}) => {
    placeHolder = placeHolder || (
        label
            ? (label.charAt(0).toUpperCase() + label.slice(1).toLowerCase())
            : (name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
    )

    return (
        <React.Fragment>
            {
                label && (
                    <label htmlFor={name} className="block text-sm leading-6 text-slate-600 font-medium dark:text-slate-400 mb-1 capitalize">
                        {label}:
                        {required && (
                            <sup className="text-red-600 text-xs pl-1">*</sup>
                        )}
                    </label>
                )
            }

            <div className="relative rounded shadow-sm block">
                <input type="text" name={name} id={name} placeholder={placeHolder} autoComplete="off"
                    className={classNames(
                        error.length > 0 ?
                            'text-red-900 ring-slate-300 dark:ring-slate-600 placeholder:text-red-400 focus:ring-red-600 border border-red-600 focus:outline-red-500' :
                            'text-slate-800I ring-slate-300 dark:ring-slate-600 placeholder:text-slate-400 dark:placeholder:text-slate-400 focus:border-0 focus:ring-orange-500 focus:outline-orange-500 border border-slate-300 dark:border-slate-600 dark:placeholder-slate-400 dark:text-white dark:ocus:ring-orange-500 dark:focus:outline-orange-500 ',
                        'text-sm border sm:text-sm rounded-md block w-full py-1.5 px-2 dark:bg-slate-800 disabled:cursor-not-allowed h-10'
                    )} onChange={changeHandler} disabled={posting} value={value} onBlur={blurHandler} required={required} />

                <div className="absolute inset-y-0 right-0 flex items-center w-8">
                    {
                        error.length > 0 ? (
                            <span className="fa-duotone text-red-500 fa-circle-exclamation fa-lg"></span>
                        ) : null
                    }
                </div>
            </div>

            {
                error.length > 0 ? (
                    <span className='invalid-feedback text-xs text-red-600 pl-1 pt-0.5'>
                        {error}
                    </span>
                ) : null
            }
        </React.Fragment>
    )
}